import Storage from './Storage';

/**
 * Store DiscountCode
 * 
 */
class DiscountCode extends Storage {
    storeName = 'discount_code_';
    hasOldKey = true;

    /**
     * DiscountCode constructor
     * 
     * @param {string} id location id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     *  @override
     * 
     * Format data for store
     * 
     * @param {any} data data to store
     * @returns 
     */
    formatSetData(data) {
        return data;
    }

    /**
     *  @override
     * 
     * Format data for store
     * 
     * @param {any} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        return data;
    }

    /**
     * @override
     * 
     * Format data for get
     * 
     * @param {any} data data to store
     * @returns 
     */
    formatGetData(data) {
        return data;
    }

}

export default DiscountCode;